export default {
  getSystemConfig: {
    method: 'get',
    url: '/system/config-data'
  },
  getSystemData: {
    method: 'get',
    url: '/system/system-data'
  },
  getLocations: {
    method: 'get',
    url: '/system/locations'
  }
}
